import { Alert } from "tailwindcss-stimulus-components"

export default class FlashNotificationsController extends Alert {
  static values = { autoHide: Boolean }

  show(){
    super.show()

    if (this.autoHideValue) {
      setTimeout(() => {
        super.close()
      }, 3000)
    }
  }
}
